<script setup>
import { computed, reactive, watch ,ref} from "vue";
import { useCrfStore } from "@/stores/crf";

import {useCommonStore} from "@/stores/common.js"
const commonStore = useCommonStore()
//不是筛选期
let notScreen = ref(false)
notScreen.value = commonStore.funNotScreen

const crfStore = useCrfStore();

// 定义组件属性
const props = defineProps({
  formModel: {},
  type: null
});

// 表单对象
const model = reactive(props.formModel);

// 节省代码长度，在模板中使用
const crfFields = computed(() => {
  return model.fields[`${props.type}`];
});

</script>
<template>
  <template v-if="crfFields">
    <h2>不良事件记录</h2>
    <!-- <el-form-item label="门高压并发症"  v-if="crfFields" class="redStar">
      <el-radio-group v-model="crfFields['门高压并发症']">
        <el-radio label="是" prop="是"></el-radio>
        <el-radio label="否" prop="否"></el-radio>
      </el-radio-group>
      <el-checkbox-group v-if="crfFields['门高压并发症'] == '是'" v-model="crfFields['门高压并发症_多选项']">
        <el-checkbox label="腹水" prop="腹水"></el-checkbox>

            <div v-if="crfFields['门高压并发症_多选项']?.includes('腹水')" class="sanjitxt">
                <el-form-item label="腹水发生日期" class="date">
                    <el-date-picker v-model="crfFields[`门高压并发症_腹水发生日期`]" type="date" :placeholder="`选择腹水发生日期`" value-format="YYYY-MM-DD" />
                </el-form-item>
                <el-form-item label="腹水转归" class="date">
                    <el-input v-model="crfFields[`门高压并发症_腹水txt`]" placeholder="请输入"></el-input>
                </el-form-item>
            </div>
        <el-checkbox label="肝性脑病" prop="肝性脑病"></el-checkbox>
           <div v-if="crfFields['门高压并发症_多选项']?.includes('肝性脑病')" class="sanjitxt">
                <el-form-item label="肝性脑病发生日期" class="date">
                    <el-date-picker v-model="crfFields[`门高压并发症_肝性脑病发生日期`]" type="date" :placeholder="`选择肝性脑病发生日期`" value-format="YYYY-MM-DD" />
                </el-form-item>
                <el-form-item label="肝性脑病转归" class="date">
                    <el-input v-model="crfFields[`门高压并发症_肝性脑病txt`]" placeholder="请输入"></el-input>
                </el-form-item>
            </div>
        <el-checkbox label="出血" prop="出血"></el-checkbox>
            <div v-if="crfFields['门高压并发症_多选项']?.includes('出血')" class="sanjitxt">
                <el-form-item label="出血发生日期" class="date">
                    <el-date-picker v-model="crfFields[`门高压并发症_出血发生日期`]" type="date" :placeholder="`选择出血发生日期`" value-format="YYYY-MM-DD" />
                </el-form-item>
                <el-form-item label="出血转归" class="date">
                    <el-input v-model="crfFields[`门高压并发症_出血txt`]" placeholder="请输入"></el-input>
                </el-form-item>
            </div>
        <el-checkbox label="其他" prop="其他"></el-checkbox>
            <div v-if="crfFields['门高压并发症_多选项']?.includes('其他')" class="sanjitxt">
                <el-form-item :label="`其他并发症名称`" class="date">
                    <el-input v-model="crfFields[`门高压并发症_其他并发症txt`]" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="发生日期" class="date">
                    <el-date-picker v-model="crfFields[`门高压并发症_其他发生日期`]" type="date" :placeholder="`选择其他发生日期`" value-format="YYYY-MM-DD" />
                </el-form-item>
                <el-form-item label="转归" class="date">
                    <el-input v-model="crfFields[`门高压并发症_其他txt`]" placeholder="请输入"></el-input>
                </el-form-item>
            </div>
      </el-checkbox-group>
    </el-form-item> -->
    <!-- 子级选项详细 -->
    <!-- <template v-for="(item, index) in crfFields['门高压并发症_多选项']" :key="index" v-if="crfFields['门高压并发症'] == '是'">
        <h5>{{item}}</h5>
         <el-form-item :label="`${item}发生日期`" class="redStar">
            <el-date-picker v-model="crfFields[`门高压并发症_${item}发生日期`]" type="date" :placeholder="`选择${item}发生日期`" value-format="YYYY-MM-DD" />
        </el-form-item>
        <el-form-item :label="`${item}转归`" class="redStar">
            <el-input v-model="crfFields[`门高压并发症_${item}txt`]" placeholder="请输入"></el-input>
        </el-form-item>
    </template> -->
    <!-- 肝肿瘤 -->

    <el-form-item :label="notScreen?'是否新增不良事件记录':'不良事件记录'"  v-if="crfFields && notScreen" class="redStar">
        <el-radio-group v-if="notScreen" v-model="crfFields['是否新增不良事件记录']">
          <el-radio label="是" prop="是"></el-radio>
          <el-radio label="否" prop="否"></el-radio>
        </el-radio-group>

    </el-form-item>
    
    <template v-if="crfFields['是否新增不良事件记录'] == '是' || !notScreen">

        <el-form-item label="肝肿瘤"  v-if="crfFields" class="redStar">
          <el-radio-group v-model="crfFields['门高压并发症_肝肿瘤']">
            <el-radio label="是" prop="是"></el-radio>
            <el-radio label="否" prop="否"></el-radio>
          </el-radio-group>
          <div class="sanjitxt" v-if="crfFields['门高压并发症_肝肿瘤'] == '是'">
            <el-form-item label="肝肿瘤发生日期" class="date">
                <el-date-picker v-model="crfFields[`门高压并发症_肝肿瘤发生日期`]" type="date" :placeholder="`选择肝肿瘤发生日期`" value-format="YYYY-MM-DD" />
            </el-form-item>
            <el-form-item label="肝肿瘤转归" class="date">
                <el-input v-model="crfFields[`门高压并发症_肝肿瘤txt`]" placeholder="请输入"></el-input>
            </el-form-item>
          </div>
        </el-form-item>
      
        <!-- 死亡 -->
        <el-form-item label="死亡"  v-if="crfFields" class="redStar">
          <el-radio-group v-model="crfFields['门高压并发症_死亡']">
            <el-radio label="是" prop="是"></el-radio>
            <el-radio label="否" prop="否"></el-radio>
          </el-radio-group>
          <div class="sanjitxt" v-if="crfFields['门高压并发症_死亡'] == '是'">
                <el-form-item label="死亡时间" class="date">
                <el-date-picker v-model="crfFields[`门高压并发症_死亡日期`]" type="date" :placeholder="`选择死亡日期`" value-format="YYYY-MM-DD" />
            </el-form-item>
            <el-form-item label="死亡原因" class="date">
                <el-input v-model="crfFields[`门高压并发症_死亡txt`]" placeholder="请输入"></el-input>
            </el-form-item>
          </div>
        </el-form-item>
      

        <el-form-item  label="其他不良事件" class="redStar">
            <el-input v-model="crfFields[`门高压并发症_其他不良事件txt`]" placeholder="请输入"></el-input>
        </el-form-item>
    </template>
  </template>
</template>

<style lang="scss" scoped>
  
        ::v-deep .el-input {
        width:200px;
     }
     .el-radio-group{
        display: block;
        width: 100%;
      }
     .el-checkbox {
        // margin-top: 10px;
        display: flex;
        // text-align: center;
      }
      .sanjitxt{
        padding-left: 17px;
        ::v-deep .date{
          // height:46px;
          margin-bottom: 10px;
        }
      }

     
</style>